import Landing from './LandingContainer';

export default Landing;
